import { Box, Grid, Typography } from "@mui/material";
import { useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { tab } from "../BrandScore/BrandScore";

import { useContext, useEffect } from "react";

import { AuthContext } from "../../../context/auth-context";
import { DiscoveryContext, useIsSelectedSection } from "../discovery-context";
import { ActionTable } from "../../Dashboard/Component/ActionComponent/ActionTable";
import { extractDomain } from "../../../utils/helpers";
import { callingForExtFocusAreasForBrandAudit } from "../../../utils/actions-helpers";
import Checkbox from "@mui/material/Checkbox";
import { ENTITY_LABELS } from "../../../utils/labelMapping";

const titleMapping = {
  reach: "Reach",
  risk: "Performance",
  sentiment: "Risk",
};


const FocusAreaOverView = ({ category, isCategoryOverview = false }) => {
  const [brandDomains, setBrandDomains] = useState([]);
  const { user } = useContext(AuthContext);
  const customerId = user?.customer_id;
  const discoveryCtx = useContext(DiscoveryContext);
  const selectedMarket = discoveryCtx?.state?.selectedMarket;
  const primaryMarket = discoveryCtx?.state?.market;
  const selectedLLM = discoveryCtx.state.selectedLLM;
  const selectedCategory = discoveryCtx.state.selectedCategory;
  const selectedPersona = discoveryCtx.state.selectedPersona;
  const primaryPersona = discoveryCtx.persona[0]?.title ?? discoveryCtx?.persona[0];
  const isShowPerformance =  primaryMarket !== selectedMarket;
  let llm = isCategoryOverview ? [selectedLLM] :discoveryCtx.llm
  let Category = [category ? category : selectedCategory];
  let market = [selectedMarket];
  let persona = [selectedPersona]
  const discoveryType = discoveryCtx.type || "brand";
  const id = "FocusArea_Overview";
  const  uniqueKey=`${tab.brandOverview}_${id}_${selectedCategory}_${selectedMarket}_${selectedPersona}`
  const { checked } = useIsSelectedSection(
    { id, tab: tab.brandOverview , uniqueKey},
  );

  let outputArr = [];
  llm.forEach((selectedLLM) => {
    Category.forEach((selectedCategory) => {
      market.map((selectedMarket) => {
        let personaWise = persona.map((selectedPersona) => {
        let obj = {
          llm: selectedLLM,
          category: selectedCategory,
          market: selectedMarket,
          persona: selectedPersona,
          brand: discoveryCtx.entity,
        };
        const brandScore =
          discoveryCtx.brand_scores?.[selectedLLM]?.[selectedCategory]?.[
            selectedMarket
          ][selectedPersona] ?? [];
        const categoryDimension =
          discoveryCtx.category_dimensions?.[selectedLLM]?.[selectedCategory]?.[primaryMarket]?.[selectedPersona] ??
          [];
        const coreAttributes =
          discoveryCtx?.core_attributes?.[selectedLLM]?.[selectedCategory]?.[primaryMarket]?.[selectedPersona] ??
          [];
        const taxonomy =
          discoveryCtx?.taxonomies?.[selectedLLM]?.[selectedCategory]?.[primaryMarket]?.[selectedPersona]?.data ?? [];
        const competitors = discoveryCtx.competitors?.[selectedCategory] ?? [];

        const output = callingForExtFocusAreasForBrandAudit({
          coreAttributes,
          taxonomy,
          categoryDimension,
          brandScore,
          competitors,
          customerId,
        });

        return {
          ...obj,
          ...output.actionsObj,
          nonActionsObj: output.nonActionsObj,
        };
      });
      outputArr.push(...personaWise);
    });
  })
  });
  useEffect(() => {
    let domain = extractDomain(
      discoveryCtx?.competitors?.["default"]?.[0]?.domain ?? "example.com"
    );
    setBrandDomains({ [discoveryCtx.entity]: domain });
  }, [discoveryCtx.competitors]);

  return (
    <>
      <br />
      {!isCategoryOverview && (
        <div className="Heading-checkbox" style={{ marginBottom: "10px" }}>
          <h5>Focus Area</h5>

          {discoveryCtx.state.showReportCheckbox && (
            <Checkbox
              checked={checked}
              onChange={() => {
                discoveryCtx?.clickComponentCheckbox({
                  uniqueKey,
                  filter: {
                    id: id,
                    title: "Focus Area",
                    tab: tab.brandOverview,
                    uniqueKey,
                    llm:null
                  },
                  checked,
                  id,
                });
              }}
              inputProps={{ "aria-label": "controlled" }}
            />
          )}
        </div>
      )}

      <Grid container spacing={1}>
        <ActionTable
          handleChange={() => {}}
          tableType="opp"
          actionMetricsData={outputArr}
          sourceAliasIds={"sourceAliasIds"}
          domaUrlsMapping={brandDomains}
          isBrandAudit={`${discoveryType === "brand"? ENTITY_LABELS.brand:ENTITY_LABELS.product}`}
          isShowPerformance={isShowPerformance}
          id={id}
        />
      </Grid>
      <ToastContainer />
    </>
  );
};

export default FocusAreaOverView;
